var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.813195 0.646447C1.00846 0.451184 1.32504 0.451184 1.5203 0.646447L6.00008 5.12623L10.4799 0.646447C10.6751 0.451184 10.9917 0.451184 11.187 0.646447C11.3822 0.841709 11.3822 1.15829 11.187 1.35355L6.35363 6.18689C6.15837 6.38215 5.84179 6.38215 5.64653 6.18689L0.813195 1.35355C0.617933 1.15829 0.617933 0.841709 0.813195 0.646447Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.cc4a71699aa16d564a3c5b1d59312262.svg";
export { ForwardRef as ReactComponent };